import {
  SET,
  LOAD_INITIAL_STATE,
  InternalCommentsActionsType,
} from '../../actions/internal-comments-actions/internal-comments.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { OrderBuilderActions, RESET_BUILDER } from '../../../../actions/order-builder.actions';

/**
 * Properties for this type of form-control
 */
export interface IInternalCommentsState {
  selected: string;
  required: boolean;
  disabled: boolean;
  visible: boolean;
  maxlength?: number;
  label?: string;
}

/**
 * A hard-coded default state for this form-field
 * @type {IInternalCommentsState}
 */
export const initialState: IInternalCommentsState = {
  selected: '',
  required: false,
  disabled: false,
  visible: false,
  maxlength: null,
  label: '',
} as IInternalCommentsState;

/**
 * Sets or loads the state of the form-field according to the Action supplied.
 * @param {IInternalCommentsState} state
 * @param {InternalCommentsActionsType} action
 * @return {IInternalCommentsState}
 */
export function internalCommentsReducer(
  state = initialState,
  action: InternalCommentsActionsType | OrderBuilderActions,
): IInternalCommentsState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const specialInstructionConfig: ILocationConfigUnit = action.payload as ILocationConfigUnit;
        return {
          ...state,
          disabled: specialInstructionConfig.disabled,
          required: specialInstructionConfig.required,
          visible: specialInstructionConfig.visible,
          maxlength: specialInstructionConfig.maxlength,
          label: specialInstructionConfig.label,
        } as IInternalCommentsState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case SET: {
      return {
        ...state,
        selected: action.payload,
      };
    }
    case RESET_BUILDER: {
      return {
        ...state,
        selected: null,
      };
    }
    default: {
      return state;
    }
  }
}
